import styled from 'styled-components';
import { Common, color } from '@stockbit/ui';

const { Text } = Common;

const PreviewPaneContainer = styled.div`
  color: ${color.nightRider};
  background-color: ${color.light};
  border-radius: 2px;
  width: 100%;
`;

const PreviewPaneItem = styled(Text).attrs({
  as: 'div',
  mt: '5px',
  mb: '30px',
  size: '14px',
})`
  line-height: 21px;
`;

export { PreviewPaneContainer, PreviewPaneItem };
